import { render, staticRenderFns } from "./IconDeliveryclub.vue?vue&type=template&id=0754b684&"
import script from "./IconDeliveryclub.vue?vue&type=script&lang=js&"
export * from "./IconDeliveryclub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports